<agm-map [latitude]="centerCoordinates.lat" [longitude]="centerCoordinates.lng" [zoom]="12"
  (centerChange)="centerChange($event)">

  <agm-marker *ngFor="let site of sites" [latitude]="site.address.lat" [longitude]="site.address.lng"
              [iconUrl]="site.mapIcon"
              [openInfoWindow]="false" (markerClick)="openSite = site.id">
    <agm-info-window [isOpen]="openSite == site.id" [zIndex]="9999999999" (infoWindowClose)="openSite = null">
      <a [routerLink]="['/customer', site.customer.id]">
        <h4>{{ site.fullName}}</h4>
      </a>
      <p> {{ site.address.street}}<br />
        {{ site.address.zip}} {{ site.address.city}} </p>
      <p>
        <button mat-raised-button type="button" color="primary" (click)="navigateTo(site)">navigieren</button>
      </p>
    </agm-info-window>
  </agm-marker>
</agm-map>

<form [formGroup]="filterForm" *ngIf="filterForm">
  <div class="row"></div>
  <mat-card class="filter-card col-sm-3" *ngIf="showFilter">
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="Suchbegriff" [formControl]="filterForm.controls['search']" />
        <mat-icon matSuffix (click)="filterForm.controls['search'].patchValue('')">close</mat-icon>
      </mat-form-field>
      <div>
        <mat-list>
          <mat-list-item>
            <mat-checkbox formControlName="today">heutige Termine</mat-checkbox>
          </mat-list-item>
          <mat-list-item *ngFor="let category of categories">
            <mat-checkbox [formControl]="filterForm.controls['categories'].controls[category.id]">{{ category.name }}
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
      </div>
      <div>
        <small>{{ sites.length == 0 ? "keine Ergebnisse": sites.length + " Ergebnisse"}}</small>
      </div>
    </mat-card-content>
  </mat-card>
  <button class="hide-toggle" (click)="showFilter = !showFilter" mat-mini-fab>
    <mat-icon>filter_list</mat-icon>
  </button>
</form>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/map/map.component.html